<template>
  <div id="HomePage">
    <div class="box">
      <Header :navList="navList" :active="0" :isScroll="true" />
      <div class="content">
        <!-- 首页 -->
        <div class="container-fuild item index">
          <img
            src="https://alggxcx.magicchair.net/uccn/index_bg1.png"
            alt="111112222"
            class="index-bg"
          />
        </div>

        <!-- 推荐系列 -->
        <div class="recommend item">
          <div
            class="container customer-container wow slideInUp"
            style="position: relative;"
          >
            <div style="position: relative;" class="hidden-xs">
              <div class="swiper-container customer-swiper">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide customer-block"
                    v-for="(item, index) in customerList"
                    :key="index"
                  >
                    <div class="customer-item">
                      <img
                        :src="item.img"
                        alt=""
                        class="customer-head"
                        @click="goPayDetail"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- 如果需要导航按钮 -->
              <!-- <div class="swiper-button-prev"></div> -->
              <!-- <div class="swiper-button-next"></div> -->
            </div>
          </div>
        </div>

        <!-- 商城 -->
        <div class="container item" @click="goPayDetail">
          <div class="container wow slideInUp">
            <img
              src="https://alggxcx.magicchair.net/uccn/index_bg7.png"
              alt=""
              style="width: 132%;margin-left: -16%;"
            />
          </div>
        </div>

        <!-- 新闻 -->
        <div class="conatiner-fuild item news-box">
          <div class="container wow slideInUp">
            <div class="row">
              <div class="col-xs-12 col-sm-6 left">
                <img
                  src="https://alggxcx.magicchair.net/uccn/index_bg6.png"
                  alt=""
                />
              </div>

              <div class="col-xs-12 col-sm-6 right">
                <div>
                  <div class="news-title">增值服务（付费）</div>
                  <div class="news-item" @click="goPay">
                    <p>【2021年科学探索奖名单公布】浙江大学（5¥）…</p>
                    <p>华为5G+AR峰会召开，巨头布局XR按下（5¥）…</p>
                    <p>6G白皮书发布：聚焦沉浸式云XR等8大业（5¥）…</p>
                    <p>乙女游戏新探索，《恋与制作人》打破虚（5¥）…</p>
                    <p>QuestMobile泛娱乐用户行为新趋势（5¥）</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 直播 -->
        <div class="conatiner-fuild item video-box" @click="goLiveDetail">
          <div class="container wow slideInUp">
            <img
              src="https://alggxcx.magicchair.net/uccn/live_00.png"
              alt=""
              style="width: 100%;"
            />
          </div>
        </div>
        <!-- 底部-->
        <Footer />
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from "wowjs";
import { getRecommendList } from "@/api";
// 引入头部组件
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "home",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      active: 0, // 当前激活的导航索引
      navList: [
        {
          id: 0,
          title: "首页",
        },
        {
          id: 1,
          title: "产品展示中心",
        },
        {
          id: 2,
          title: "在线商城",
          // url: "/online_store",
        },
        {
          id: 3,
          title: "增值服务（付费）",
        },
        {
          id: 4,
          title: "直播",
        },
        {
          id: 5,
          title: "联系我们",
        },
        {
          id: 6,
          title: "登录",
        },
        {
          id: 7,
          title: "注册",
        },
      ],
      // 推荐系列
      customerList: [
        {
          img: "https://alggxcx.magicchair.net/uccn/index_bg2.svg",
        },
        {
          img: "https://alggxcx.magicchair.net/uccn/index_bg3.svg",
        },
        {
          img: "https://alggxcx.magicchair.net/uccn/index_bg4.svg",
        },
      ],
    };
  },
  mounted() {
    this.getRecommendList();
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  },
  methods: {
    goPay() {
      this.$router.push("/pay");
    },
    goPayDetail() {
      this.$router.push("/pay_detail");
    },
    goLiveDetail() {
      this.$router.push("/live_detail");
    },
    // 获取推荐系列
    getRecommendList() {
      let that = this;
      setTimeout(function() {
        /* customer-swiper */
        new Swiper(".customer-swiper", {
          // pagination: '.swiper-pagination',
          // loop: true, // 循环模式选项
          slidesPerView: 3,
          paginationClickable: true,
          //自动播放
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          // 如果需要前进后退按钮
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
        });

        /* customer-swiper2 */
        new Swiper(".customer-swiper2", {
          loop: true, // 循环模式选项
          pagination: {
            el: ".swiper-pagination",
          },
          //自动播放
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
        });
      }, 500);
    },
  },
};
</script>
<style scoped lang="scss">
.title {
  width: max-content;
  font-size: 32px;
  color: #ffffff;
  background: linear-gradient(
    84deg,
    #93d0f6 0%,
    #9991fa 58.1787109375%,
    #c284ff 98.92578125%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: auto;
}
::v-deep .box{
  .header-nav-wrapper{
    margin-top: 10px!important;
  }
}
.video-box {
  background: #000;
  padding-top: 170px;
}
.news-box {
  // height: 1080px;
  background: #f2f4fe;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 200px 0;
  .left {
    img {
      width: 100%;
      height: 569px;
    }
  }
  .right {
    display: flex;
    justify-content: flex-end;
    .news-title {
      font-size: 36px;
      font-weight: 500;
      color: #333333;
      margin-bottom: 14px;
      position: relative;
      top: -6px;
    }
    .news-item {
      p {
        width: 510px;
        height: 88px;
        border-radius: 8px;
        background: #edeffe;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        line-height: 90px;
        margin-bottom: 16px;
        color: #333333;
      }
    }
  }
}
// 首页
.index {
  .index-bg {
    width: 100%;
  }
  .left {
    padding-top: 60px;
  }
  .right {
    img {
    }
  }
  .txt1 {
    font-size: 70px;
    font-weight: bold;
    text-align: center;
    font-family: SourceHanSansCN-Regular;
    position: absolute;
    top: 330px;
    left: 50%;
    // top: 50%;
    transform: translate(-50%, -50%);
  }
}

/* 推荐系列 */
.recommend {
  box-sizing: border-box;
  transition: all ease 0.6s;
  background: url(https://alggxcx.magicchair.net/uccn/index_bg5.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 200px 0;
  width: 100%;

  .swiper-button-next {
    // background: url(../../src/assets/img/right_arrow.png) no-repeat;
  }
  .swiper-button-prev {
    // background: url(../../src/assets/img/left_arrow.png) no-repeat;
  }
  .customer-swiper {
    width: 100%;
  }
  .title {
    padding: 60px 0 60px 0;
  }
  .swiper-button-prev {
    left: 0;
  }
  .swiper-button-next {
    right: 0;
  }
  .customer-block {
    padding: 15px;
    .customer-item {
      background: rgb(50, 41, 75);
      border-radius: 20px;
      overflow: hidden;
      .customer-head {
        width: 100%;
        border-radius: 20px;
      }
      .customer-bottom {
        padding: 16px 16px;
        .customer-author {
          margin-top: 10px;
          img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }
      }
    }
  }
}

.placeholder {
  height: 60px;
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .box {
    background: none;
  }
  .recommend {
    padding: 0;
    height: auto;
  }
  .news-box {
    padding: 30px 0;
  }
  .index {
    padding: 20px 0 20px 0;
    height: auto;
    .row {
      margin-right: -15px;
      margin-left: -15px;
    }
    .left {
      padding-top: 0px;
      text-align: center;
    }
    .txt1 {
      font-size: 33px;
    }
    .txt2 {
      font-size: 24px;
    }
    .right {
      img {
        width: 100%;
      }
    }
    .botton {
    }
  }
  .title {
    font-size: 28px;
  }
  .placeholder {
    height: 60px;
  }
  .recommend {
    .customer-block {
      padding-bottom: 40px;
    }
    .title {
      padding: 30px 0 30px 0;
    }
  }

  .footer {
    .line {
      margin-top: 36px;
      margin-bottom: 20px;
    }
    .tit1 {
      padding-left: 0px;
    }
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
}

@media screen and (max-width: 997px) {
}
</style>
